export default "__VITE_ASSET__DX$6zzqW__"